import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

const CustomDropMenu = (props) => {
  const { icon, text, children } = props;
  return (
    <Menu as="div" className="relative  z-40">
      <MenuButton className=" whitespace-nowrap flex items-center gap-x-1.5 px-3 relative cursor-pointer md:px-1.5">
        {icon}
        <h3 className="text-sm font-medium text-gray-1 hidden md:block">
          {text}
        </h3>
        <span className="absolute top-0.5 right-0.5"></span>
      </MenuButton>
      <MenuItems className="absolute top-[160%] p-2 rounded-md border border-gray-2 bg-white-1 shadow-[0px_4px_6px_rgba(0,0,0,0.09)] text-sm font-medium leading-5 text-blue-4 flex flex-col items-start">
        {Array.isArray(children) ? (
          children.map((child, index) => (
            <MenuItem
              key={index}
              as="div"
              className="w-full p-1 cursor-pointer"
            >
              {child}
            </MenuItem>
          ))
        ) : (
          <MenuItem as="div" className="w-full p-1 cursor-pointer">
            {children}
          </MenuItem>
        )}
      </MenuItems>
    </Menu>
  );
};

export default CustomDropMenu;
